import { isAxiosError } from 'axios';
import { z } from 'zod';
import type { translations } from '@/translations/translations';

const phraseSchema = z.object({
  id: z.string().uuid().optional(),
  local: z.string().min(1).max(10_000),
  fr: z.string().max(10_000),
  source: z.string().max(2_000).optional(),
  domain: z.string().max(500).optional(),
}).strict();

const metaSchema = z.object({
  request_id: z.string().uuid(),
  served_at: z.string().datetime(),
}).strict();

export const phraseListResponseSchema = z.object({
  error: z.literal(false),
  status: z.literal(200),
  message: z.literal('PHRASES_READ'),
  data: z.object({
    total: z.number().int().nonnegative(),
    totalPages: z.number().int().nonnegative(),
    page: z.number().int().positive(),
    limit: z.number().int().positive().max(100),
    data: z.array(phraseSchema).max(100),
  }).strict(),
  meta: metaSchema,
}).strict();

const errorCodeSchema = z.enum([
  'VALIDATION_FAILED',
  'UNAUTHORIZED',
  'FORBIDDEN',
  'NOT_FOUND',
  'INTERNAL_SERVER_ERROR',
]);

const errorEnvelopeSchema = z.object({
  error: z.literal(true),
  status: z.number().int().min(400).max(599),
  message: errorCodeSchema,
  data: z.null(),
  meta: metaSchema.extend({
    retryable: z.boolean().optional(),
    violations: z.array(z.string()).max(100).optional(),
  }).strict(),
}).strict();

export function phraseListErrorMessage(
  error: unknown,
  messages: typeof translations.fr.phraseListErrors,
): string {
  if (!isAxiosError(error)) return messages.DEFAULT;
  const parsed = errorEnvelopeSchema.safeParse(error.response?.data);
  if (!parsed.success || parsed.data.status !== error.response?.status) return messages.DEFAULT;
  return messages[parsed.data.message];
}
